export default "__VITE_ASSET__CwXI76Zj__ 720w";